import PackageBoxes from "./packageBoxes";
import SpecialAddons from "./specialAddons";
import PlanBoxes from "./PlanBoxes";

export class GenerateProducts{
    constructor(){
        this.packages = new PackageBoxes()
        this.products = new SpecialAddons()
        this.planboxes = new PlanBoxes();
    }
    render(){
        this.packages.render()
        this.products.render()
        this.planboxes.render();
    }
}